/* Core & libraries */
import React from "react";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import { FlagsMap } from '../../helpers/flagsMap';

/* Styles */
import styles from "./styles.js"
import { useTheme } from 'react-jss';

const FlagIconComponent = ( { locale, flagClassName = '' }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  if (!locale) return null;

  const countryCode = locale.split("_")[1]?.toUpperCase();
  if (!countryCode) return null;

  const FlagIcon = FlagsMap[countryCode] || FlagsMap['EARTH'];

  return (
    <FlagIcon
      className={`${classes.flag} ${flagClassName}`.trim()}
    />
  );
};

export default FlagIconComponent;